import { render, staticRenderFns } from "./DataApi.vue?vue&type=template&id=2cadd6b9&scoped=true&"
import script from "./DataApi.vue?vue&type=script&lang=js&"
export * from "./DataApi.vue?vue&type=script&lang=js&"
import style0 from "./DataApi.vue?vue&type=style&index=0&id=2cadd6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadd6b9",
  null
  
)

export default component.exports